<template>
  <div style="margin: 0 24px 8px;">
    <el-form ref="formRef" :model="priceForm" label-width="100px" label-position="right">
      <el-form-item label="店铺名称：">
        <el-select v-model="shopId" placeholder="Select" style="width: 20em">
          <el-option v-for="item in shopIdArr" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目名称：">
        <el-select v-model="projectId" placeholder="Select" style="width: 20em" @change="projectChange" >
          <el-option v-for="item in projectIdArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="priceForm.orderNum" placeholder="数值越大越靠前" style="width: 20em"/>
      </el-form-item>
<!--      <el-form-item label="类型：">-->
<!--        <el-radio-group v-model="type">-->
<!--          <el-radio :label="1">金额</el-radio>-->
<!--          <el-radio :label="2">张数</el-radio>-->
<!--        </el-radio-group>-->
<!--      </el-form-item>-->
      <el-form-item label="价格：" v-if="projectType == 1">
        <el-input v-model="priceForm.price" placeholder="请输入价格" style="width: 20em">
          <template #suffix>元</template>
        </el-input>
      </el-form-item>
<!--      <el-form-item label="张数：" v-if="projectType == 2">-->
<!--        <el-input v-model="amount" placeholder="请输入张数" style="width: 20em">-->
<!--          <template #suffix>张</template>-->
<!--        </el-input>-->
<!--      </el-form-item>-->
      <el-form-item label="会员权益：" v-if="projectType == 1">
        <el-radio-group v-model="isPrivilege">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import { addOrUpdateShopProject, listProject } from "@/api/url";

export default {
  name: "ProjectPriceDialog",
  props: {
    value: Object
  },
  data() {
    return {
      priceForm: this.value.priceForm,
      isPrivilege: this.value.ids == -1?0:this.value.priceForm.isPrivilege,
      idx: this.value.ids,
      shopIdArr: this.value.shopIdArr,
      shopId: '',
      projectId: '',
      projectIdArray: [],
      projectList: [],
      // amount:this.value.priceForm.amount?this.value.priceForm.amount:1,
      projectType: '',
    }
  },
  methods: {

    projectChange(val) {
      for(let i=0; i<this.projectList.length; i++) {
        if(val == this.projectList[i].id) {
          this.projectType = this.projectList[i].type
          if(this.projectType == 2) {
            this.isPrivilege = 0
            this.priceForm.price = 0
          }
        }
      }
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.priceForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.priceForm.price && this.projectType == 1) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '价格不能为空',
          type: 'warning'
        });
        return false
      }
      let param = {}

      param['id'] = this.idx > -1?this.priceForm.id:0;
      param['orderNum'] = this.priceForm.orderNum;
      param['price'] = this.priceForm.price;
      // param['amount'] = this.amount;
      param['shopId'] = this.shopId;
      param['projectId'] = this.projectId;
      param['projectType'] = this.projectType;
      param['isPrivilege'] = this.isPrivilege;
      postFormData(addOrUpdateShopProject, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    getProjectList() {
      getFormData(listProject, {projectType: 1}).then(data => {
        let {msg, code} = data
        if (code == 200) {
          this.projectList = data.data
          this.projectIdArray = []
          this.projectList.map(item => {
            let obj = {}
            obj.label = item.name
            obj.value = item.id
            obj.type = item.type
            this.projectIdArray.push(obj)
          })
          if(this.idx > -1) {
            this.projectId = this.priceForm.projectId
            this.projectType = this.priceForm.projectType
          }else {
            // console.log(this.projectIdArray)
            this.projectId = this.projectIdArray[0].value
            this.projectType = this.projectIdArray[0].type
          }
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    }


  },
  mounted() {
    this.getProjectList()
    if(this.idx > -1 ) {
      this.shopId = this.priceForm.shopId
    }else {
      this.shopId = this.shopIdArr[0].id
    }
  }
}
</script>

<style scoped>

</style>
